import { useAbility } from '@/hooks/useAbility';
import { useOptionalUserQuery } from '@/hooks/useOptionalUserQuery';
import { Action, Subject } from '@/modules/api/backend';
import type { RouterLinkOptions } from '@/types/RouterLinkOptions';

export function useManagementLinks(): RouterLinkOptions[] {
  const { data: user } = useOptionalUserQuery();

  const { ability } = useAbility();

  if (!user || !ability) return [];

  const links: RouterLinkOptions[] = [
    { title: 'Stationen und P+R Anlagen', link: { to: '/management/stations' } },
    { title: 'Sonstige Parkraumangebote', link: { to: '/management/stationless' } },
  ];

  if (ability.can(Action.MANAGE, Subject.All)) {
    links.push(
      { title: 'Organisationen', link: { to: '/management/organizations' } },
      { title: 'Benutzer*innen', link: { to: '/management/users' } },
    );
  } else if (user.organization && ability.can(Action.READ, Subject.Organization)) {
    links.push({
      title: user.organization.organization?.name ?? 'Organisation',
      link: {
        to: '/management/organizations/$organizationId' as const,
        params: { organizationId: user.organization.organizationId },
      },
    });
  }

  return links;
}
